module.exports = __webpack_public_path__ + "img/ProcessNormal.3e9804d4.svg";